import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import MerchantIcon from "../../Icons/MerchantIcon";
const MerchantInvoiceComponent = loadable(
  () => import("../../components/MerchantInvoice/MerchantInvoiceList")
);
const MerchantInvoice = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <MerchantIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Merchant Statement List
        </span>
      </div>
      <MerchantInvoiceComponent />
    </>
  );
};

export default MerchantInvoice;
